// ClassCreate.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";

const ClassCreate = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  const handleRemovePhoto = (e) => {
    e.stopPropagation();
    setFile(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", title);
    if (file) data.append("cover", file);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/class/create`,
        data,
        { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
      );
      toast.success("Kayıt başarılı!");
      setTimeout(() => navigate("/classes/table"), 1500);
    } catch (err) {
      console.error("❌ Kayıt hatası:", err);
      toast.error("Kayıt başarısız oldu!");
    }
  };

  return (
    <div className="container mt-4">
      <form className="card p-4" onSubmit={handleSubmit}>
        <h5 className="mb-3 fw-bold">Sınıf Oluştur</h5>

        <div className="mb-3">
          <label className="form-label">Başlık</label>
          <input
            type="text"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Görsel</label>
          <Dropzone
            onDrop={(files) => setFile(files[0])}
            accept={{ "image/*": [] }}
          >
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps()}
                className="border p-3 text-center position-relative"
                style={{ cursor: "pointer" }}
              >
                <input {...getInputProps()} />
                {file ? (
                  <div>
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      className="img-thumbnail mb-2"
                      style={{ maxHeight: 120 }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={handleRemovePhoto}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <p>Buraya sürükleyin veya tıklayın, dosya seçin.</p>
                )}
              </div>
            )}
          </Dropzone>
        </div>

        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary">
            Kaydet
          </button>
        </div>
      </form>
    </div>
  );
};

export default ClassCreate;
